import isEntitySupported from './isEntitySupported';
import { SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE } from '../../helpers/TxpCommonConstants';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    SERVICE_RESERVATION_FEATURE,
    SERVICE_RESERVATION_ADAPTIVE_FEATURE,
} from '../../helpers/FeatureFlagName';

export default function isServiceReservationSupported(entityNamesMap: number): boolean {
    return isEntitySupported(
        entityNamesMap,
        SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE,
        isFeatureEnabled(SERVICE_RESERVATION_FEATURE) &&
            !isFeatureEnabled(SERVICE_RESERVATION_ADAPTIVE_FEATURE)
    );
}
